const storageKey = 'weekly-report.pending-link';

// Keep the report credential in this tab for loading, submitting, and refreshing the clean URL.
export const rememberWeeklyReportToken = (token: string) => sessionStorage.setItem(storageKey, token);
export const pendingWeeklyReportToken = () => sessionStorage.getItem(storageKey);
